import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { generatePath } from 'mini-react-router-dom';
import { INBOX_FOLDER_NAME } from 'mini-mail-common/lib/utils/folderNameConstants';
import { isValidMailFolderId, selectFolder } from 'mini-mail-folder-actions';
import { type MailRoutes } from 'mini-routes';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'mini-react-router-dom';

export const useHandleMailFolderNavigation = () => {
    const navigate = useNavigate();
    const { folderId } = useParams();

    useEffect(() => {
        const decodedFolderId = decodeURIComponent(folderId);
        const effectiveFolderId = folderNameToId(decodedFolderId) || decodedFolderId;
        if (!effectiveFolderId || !isValidMailFolderId(effectiveFolderId)) {
            navigate(generatePath('/:folderId', { folderId: INBOX_FOLDER_NAME }), {
                replace: true,
            });
        } else {
            selectFolder(effectiveFolderId);
        }
    }, [folderId, navigate]);
};
